import { PubSub } from "aws-amplify";

function publishOnTopic(topic: string, message: object | string): void {
  console.log('Sending:', topic, message);
  PubSub.publish(topic, message as any)
    .catch(e => {
      console.log('Error: ', e);
    });
}

export default publishOnTopic;
